const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/eCheckin/sections/KostenUebernahme.tsx';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import textMap from '../translations';
import { createFieldPath } from 'App/components/eCheckin/utils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { LabelLink } from 'App/components/eCheckin/components/fields/LabelLink';

export const Kostenuebernahme = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_COSTS_AND_CONSENT_DATA = createFieldPath(path, 'datenweitergabeText');
    const PATH_PRIVACY_POLICY = createFieldPath(path, 'privacyPolicy');

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox
                label={textMap.datenweitergabeText}
                path={PATH_COSTS_AND_CONSENT_DATA}
                required
            />
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.privacyPolicyText, {
                    link: (
                        <LabelLink
                            text={textMap.privacyPolicyLink}
                            url="https://www.sro.ch/datenschutz/"
                        />
                    ),
                })}
                path={PATH_PRIVACY_POLICY}
                required
            />
        </ECheckinSection>
    );
});

Kostenuebernahme.displayName = 'Kostenuebernahme';
